import posthog from "posthog-js";
import { config } from "./env";

const POSTHOG_API_KEY = "phc_oUBklUthDs81pUJJoE0K1jE8no9i9tleKxN155g4FIH";
const POSTHOG_HOST = "https://us.i.posthog.com";

export function initPostHog() {
	if (!config.isProduction) return;

	posthog.init(POSTHOG_API_KEY, {
		api_host: POSTHOG_HOST,
		autocapture: true,
		capture_pageview: true,
		capture_pageleave: true,
		persistence: "localStorage+cookie",
		session_recording: {
			maskAllInputs: true,
			maskTextSelector: "[data-posthog-mask]",
		},
	});
}

export function setPostHogUser(user: { id: string; email?: string } | null) {
	if (!config.isProduction) return;

	if (user) {
		posthog.identify(user.id, { email: user.email });
	} else {
		posthog.reset();
	}
}

export { posthog };
